export const TIPOSIDENTIFICACION = [
    {
        label: "RUC",
        value: "RUC"
    },
    {
        label: "Pasaporte",
        value: "PASAPORTE"
    },
    {
        label: "Cédula",
        value: "CEDULA"
    }
];